import React, { useState } from "react";
import Icon from "../../../../../../components/MainApp/atoms/Icon/icon";
import InputText from "../../../../../../components/MainApp/atoms/Forms/MainInput";
import ItemTags from "components/MainApp/organisms/OrdersV3/Item-Tags";
import DeviceSelector from "components/Functionals/DeviceSelector";
import styles from "./ValidateMovementItems.module.scss";
import i18n from "i18n";
import TagReadInput from "shared/components/Input/TagReadInput";

export const ValidateMovementItems = ({
  enabledRead,
  typeRead,
  refRead,
  associateRead,
  priorityRead,
  receiveEvent,
  selectedItems = [],
  total,
  totalValidate,
  handleSearch,
  handleReject,
  handleApprove,
  goBack,
}) => {
  const [searchedValue, setsearchedValue] = useState("");

  const searchValue = (e) => {
    setsearchedValue(e.target.value);
  };

  const handleSubmit = function (e) {
    e.preventDefault();
    handleSearch(searchedValue);
    setsearchedValue("");
  };

  return (
    <div className={styles["validate-movement-items-outter"]}>
      <div className={styles["validate-movement-items-wrapper"]}>
        <div className={styles["validate-movement-items-title-wrapper"]} onClick={goBack}>
          <div className={styles["validate-movement-items-title-icon"]}>
            {" "}
            <Icon name="chevron" width={14} height={14} fill={"#62D862"} />
          </div>
          <h1 className={styles["validate-movement-items-title"]}>
            {i18n.t("product.supervision")}
          </h1>
        </div>
        <div className={styles["device-selector-wrapper"]}>
          <DeviceSelector
            enabled={enabledRead}
            typeRead={typeRead}
            refRead={refRead}
            associateRead={associateRead}
            priorityRead={priorityRead}
            receiveEvent={receiveEvent}
            includeType={"MOB_READER"}
          />
        </div>
        <div className={styles["validate-movement-items-content"]}>
          <div className={styles["validate-movement-items-input-wrapper"]}>
            <div className={styles["validate-movement-tagreadinput-wrapper"]}>
              <TagReadInput searchValue={searchValue} searchedValue={searchedValue} handleSubmit={handleSubmit} />
            </div>
          </div>
          <div className={styles["validate-movement-items-count"]}>
            {totalValidate}/{total}
          </div>
          <div className={styles["validate-movement-items-list"]}>
            {selectedItems.map((item) => {
              return (
                <ItemTags
                  key={item.sku}
                  item={item}
                  type="verification"
                  quantity={item.tags.filter((t) => t.selected).length}
                  expected={item.tags.length}
                />
              );
            })}
          </div>
          <div className={styles["validate-movement-items-buttons-wrapper"]}>
            <div
              className={`${styles["validate-movement-items-button"]} ${styles["validate-movement-items-clean"]}`}
              onClick={handleReject}
            >
              {" "}
              {i18n.t("decline")}{" "}
            </div>
            <div
              className={`${styles["validate-movement-items-button"]} ${styles["validate-movement-items-send"]}`}
              onClick={handleApprove}
            >
              {i18n.t("approve")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidateMovementItems;
